
import { lazy, Suspense } from "react";

const LazyComponent = lazy(() => import("./Icon"));

const Icon = (props: any) =>
  <Suspense fallback={<i style={{ width: 12 }}>&middot;</i>}>
    <LazyComponent {...props} />
  </Suspense>;

export default Icon;

